import gridbase, {times} from '../../mixins'

export default {
  mixins: [gridbase, times],
  props: {
    available_devices: {required: true},
  },
}


// WEBPACK FOOTER //
// ./src/apps/feelgrid/modules/pureData/base.js